<div class="profile-menu">
  <div class="btn-group" role="group">
    <app-profile-selector />
  </div>
  <div class="pt-3 pb-2">
    <ul class="profile-menu-items mb-3">
      <li
        class="simple-menu-item {{
          selectedMenu() === 'personal-info' ? 'active' : ''
        }}"
        (click)="selectMenu('personal-info')"
      >
        <div class="menu-item-header">
          <span class="title">{{ "profile.personalInfo" | translate }}</span>
        </div>
      </li>
      <li
        class="menu-group-header"
        [class.active]="selectedMenu().startsWith('investments')"
      >
        <div
          class="menu-item-header"
          (click)="toggleCollapse('investments')"
          [attr.aria-expanded]="!isInvestmentsCollapsed()"
          aria-controls="investmentsCollapse"
        >
          <span class="title">{{
            "profile.investments.title" | translate
          }}</span>
          <i
            class="fas {{
              isInvestmentsCollapsed() ? 'fa-chevron-down' : 'fa-chevron-up'
            }}"
          ></i>
        </div>
        <ul id="investmentsCollapse" [ngbCollapse]="isInvestmentsCollapsed()">
          <li
            class="sub-menu-item"
            [class.active]="selectedMenu() === 'investments.accepted'"
            (click)="selectMenu('investments.accepted')"
          >
            <div class="menu-item-header">
              <span class="title">{{
                "profile.investments.accepted" | translate
              }}</span>
            </div>
          </li>
          <li
            class="sub-menu-item"
            [class.active]="selectedMenu() === 'investments.pending'"
            (click)="selectMenu('investments.pending')"
          >
            <div class="menu-item-header">
              <span class="title">{{
                "profile.investments.pending" | translate
              }}</span>
            </div>
          </li>
          <li
            class="sub-menu-item"
            [class.active]="selectedMenu() === 'investments.rejected'"
            (click)="selectMenu('investments.rejected')"
          >
            <div class="menu-item-header">
              <span class="title">{{
                "profile.investments.rejected" | translate
              }}</span>
            </div>
          </li>
        </ul>
      </li>
      <li
        class="simple-menu-item {{
          selectedMenu() === 'watched-projects' ? 'active' : ''
        }}"
        (click)="selectMenu('watched-projects')"
      >
        <div class="menu-item-header">
          <span class="title">{{
            "profile.watchedProjects.title" | translate
          }}</span>
        </div>
      </li>
      <li
        class="simple-menu-item {{
          selectedMenu() === 'support-request' ? 'active' : ''
        }}"
        (click)="selectMenu('support-request')"
      >
        <div class="menu-item-header">
          <span class="title">{{ "profile.complaint" | translate }}</span>
        </div>
      </li>
      <li
        class="simple-menu-item {{
          selectedMenu() === 'message' ? 'active' : ''
        }}"
        (click)="selectMenu('message')"
      >
        <div class="menu-item-header">
          <span class="title">{{ "profile.message" | translate }}</span>
        </div>
      </li>
    </ul>
  </div>
</div>
<div class="profile-details">
  <div class="buttons-container">
    <div class="left-side-buttons">
      @if (authStore.isUserQualifiedInvestor()) {
        <button
          class="btn btn-light dropdown-trigger"
          type="button"
          [disabled]="isProfessionalClient()"
          (click)="onQualificationButtonClick()"
        >
          <div class="profile-selection-button-content">
            <span class="profile-selection-icon fas fa-star"></span>
            <div class="profile-selection-button-text">
              <span>{{ "profile.qualifiedInvestor" | translate }}</span>
            </div>
          </div>
        </button>
      } @else {
        <button
          class="btn btn-light dropdown-trigger"
          type="button"
          [disabled]="isProfessionalClient()"
          (click)="onQualificationButtonClick()"
        >
          <div class="profile-selection-button-content">
            <span class="profile-selection-icon fas fa-graduation-cap"></span>
            <div class="profile-selection-button-text">
              <span>{{ "profile.unQualifiedInvestor" | translate }}</span>
              <a>{{
                "profile.reQualify" | translate
              }}</a>
            </div>
          </div>
        </button>
      }
    </div>
  </div>
  <router-outlet />
</div>
